import { route, meta } from '@/helpers/routes'

import { routes as agendas } from './agendas'
import { routes as dashboard } from './dashboard'
import Config from './config/index'
import { routes as terms } from './terms'
import { routes as policy } from './privacy-policy'
import { routes as favoriteList } from './favorite-list'
import { routes as notifications } from './notifications'

const patientAdvancedSettings = [
  route('/app/settings/config/index', '/app/settings/config/index', Config, meta('Dashboard Paciente', true, 'guest'))
]

export default [
  ...agendas,
  ...dashboard,
  ...patientAdvancedSettings,
  ...terms,
  ...policy,
  ...favoriteList,
  ...notifications
]



// WEBPACK FOOTER //
// ./src/app/patient/routes.js